import { useTranslation } from 'react-i18next';
import { Heart } from 'lucide-react';
import Card from '../ui/Card';
import GoldButton from '../ui/GoldButton';
import WhatsAppButton from '../ui/WhatsAppButton';

const PHOTO_ALBUM_URL =
  (import.meta.env?.VITE_PHOTO_ALBUM_URL as string | undefined) ?? 'https://photos.app.goo.gl/r28Fr5RAZVF7Xg376';

export default function Confirmations() {
  const { t } = useTranslation();

  return (
    <section
      id="confirm-attendance"
      className="bg-brand-paper border-y border-brand-gold/20"
      aria-label="Confirmations"
    >
      <div
        id="gallery"
        className="mx-auto max-w-4xl px-6 py-20 sm:py-28 grid grid-cols-1 md:grid-cols-2 gap-6"
      >
        <Card>
          <h3 className="font-serif uppercase tracking-widest text-brand-gold text-lg">
            {t('confirmations.rsvpTitle')}
          </h3>
          <div className="gold-divider" />
          <p className="font-serif italic text-brand-ink/85 leading-relaxed mt-2">
            {t('confirmations.rsvpBody')}
          </p>
          <div className="mt-6 flex flex-col items-center gap-3 w-full">
            <WhatsAppButton />
          </div>
        </Card>

        <Card>
          <h3 className="font-serif uppercase tracking-widest text-brand-gold text-lg">
            {t('confirmations.photosTitle')}
          </h3>
          <div className="gold-divider" />
          <p className="font-serif italic text-brand-ink/85 leading-relaxed mt-2">
            {t('confirmations.photosBody')}
          </p>
          <div className="mt-6">
            <GoldButton as="a" href={PHOTO_ALBUM_URL} target="_blank" rel="noopener noreferrer">
              {t('confirmations.photosButton')}
            </GoldButton>
          </div>
          <p className="mt-5 inline-flex items-center gap-1 font-serif italic text-sm text-brand-ink/70">
            <Heart size={14} className="text-brand-gold" aria-hidden="true" />
            <span>{t('confirmations.photosCaption')}</span>
          </p>
        </Card>


      </div>
    </section>
  );
}
